export default __webpack_public_path__ + "static/media/rtWaitingMuchIcon.b2f454d1.webp";